import React from 'react'
// import ReactGA from 'react-ga'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

import equilibrae from "../img/sucos/equilibrae/caixa.png"
import equilibrae_tabela from "../img/sucos/equilibrae/tabela.png"

import badum from "../img/sucos/badum/caixa.png"
import badum_tabela from "../img/sucos/badum/tabela.png"

import xuaah from "../img/sucos/xuaah/caixa.png"
import xuaah_tabela from "../img/sucos/xuaah/tabela.png"

import pinklemonade from "../img/sucos/pinklemonade/caixa.png"
import pinklemonade_tabela from "../img/sucos/pinklemonade/tabela.png"

import uva from "../img/sucos/uva/caixa.png"
import uva_tabela from "../img/sucos/uva/tabela.png"

import malaboroso from "../img/sucos/malabaroso/caixa.png"
import malaboroso_tabela from "../img/sucos/malabaroso/tabela.png"

import maca from "../img/sucos/maca/caixa.png"
import maca_tabela from "../img/sucos/maca/tabela.png"

// FRUTAS
import pinklemonade_morango from "../img/sucos/pinklemonade/morango.png"
import pinklemonade_limao from "../img/sucos/pinklemonade/limao.png"
import pinklemonade_folha1 from "../img/sucos/pinklemonade/folha1.png"
import pinklemonade_folha2 from "../img/sucos/pinklemonade/folha2.png"
import pinklemonade_maca_cortada from "../img/sucos/pinklemonade/maca_cortada.png"
import pinklemonade_maca from "../img/sucos/pinklemonade/maca_inteira.png"

import equilibrae_morango from "../img/sucos/equilibrae/morango.png"
import equilibrae_banana1 from "../img/sucos/equilibrae/banana1.png"
import equilibrae_banana2 from "../img/sucos/equilibrae/banana2.png"
import equilibrae_folha1 from "../img/sucos/equilibrae/folha1.png"
import equilibrae_folha2 from "../img/sucos/equilibrae/folha2.png"
import equilibrae_maca_cortada from "../img/sucos/equilibrae/maca_cortada.png"
import equilibrae_maca from "../img/sucos/equilibrae/maca.png"

import malabaroso_manga from "../img/sucos/malabaroso/manga.png"
import malabaroso_laranja from "../img/sucos/malabaroso/laranja.png"
import malabaroso_maca from "../img/sucos/malabaroso/maca.png"
import malabaroso_pessego from "../img/sucos/malabaroso/pessego.png"
import malabaroso_folha1 from "../img/sucos/malabaroso/folha1.png"
import malabaroso_folha2 from "../img/sucos/malabaroso/folha2.png"
import malabaroso_folha3 from "../img/sucos/malabaroso/folha3.png"

import maca_folha1 from "../img/sucos/maca/folha1.png"
import maca_folha2 from "../img/sucos/maca/folha2.png"
import maca_folha3 from "../img/sucos/maca/folha3.png"
import maca_maca_cortada from "../img/sucos/maca/maca_cortada.png"
import maca_maca from "../img/sucos/maca/maca.png"

import badum_maca from "../img/sucos/badum/maca.png"
import badum_morango from "../img/sucos/badum/morango.png"
import badum_folha1 from "../img/sucos/badum/folha1.png"
import badum_folha2 from "../img/sucos/badum/folha2.png"
import badum_tangerina from "../img/sucos/badum/tangerina.png"
import badum_laranja from "../img/sucos/badum/laranja.png"

import uva_uva1 from "../img/sucos/uva/uva1.png"
import uva_uva2 from "../img/sucos/uva/uva2.png"
import uva_folha1 from "../img/sucos/uva/folha1.png"
import uva_folha2 from "../img/sucos/uva/folha2.png"

import xuaah_maca from "../img/sucos/xuaah/maca_inteira.png"
import xuaah_maca_cortada from "../img/sucos/xuaah/maca_cortada.png"
import xuaah_abacaxi1 from "../img/sucos/xuaah/abacaxi1.png"
import xuaah_abacaxi2 from "../img/sucos/xuaah/abacaxi2.png"
import xuaah_folha1 from "../img/sucos/xuaah/folha1.png"
import xuaah_folha3 from "../img/sucos/xuaah/folha3.png"
import xuaah_folha4 from "../img/sucos/xuaah/folha4.png"
import xuaah_folha5 from "../img/sucos/xuaah/folha5.png"

class Produtos extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      sucos: [
        {
          nome: "equilibraê",
          bg: ["#6dcff6","#fdd1b0","#00c5b4"],
          color: "#f04e6e"
        },
        {
          nome: "malabaroso",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "maçã",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "badum",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "uva",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "pink lemonade",
          bg: ["#00c5b4","#6dcff6","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "xuaah",
          bg: ["#00c5b4","#6dcff6","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "equilibraê",
          bg: ["#6dcff6","#fdd1b0","#00c5b4"],
          color: "#f04e6e"
        },
        {
          nome: "malabaroso",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "maçã",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "badum",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "uva",
          bg: ["#6dcff6","#00c5b4","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "pink lemonade",
          bg: ["#00c5b4","#6dcff6","#fdd1b0"],
          color: "#ffd65c"
        },
        {
          nome: "xuaah",
          bg: ["#00c5b4","#6dcff6","#fdd1b0"],
          color: "#ffd65c"
        }
      ],
      activeSuco: 0,
      sliderVisible: true,
      detailsVisible: false,
      activeSucoDetails: null,
      showDetails: false,
      iniPos: null,
      p1: 10,
      p2: 20,
      p3: 30,
      p4: 40,
      p5: 50
    }
  }
  
  componentDidMount () {
    // ReactGA.initialize('UA-55278565-1')
    // ReactGA.pageview('/produtos')
  }

  updateParallax = () => {
    var x = this.props.scroll

    if(x != null) {
      var iniOffset = (window.innerHeight > (window.innerHeight * .8) ? (window.innerHeight * .8) : window.innerHeight)
          iniOffset = iniOffset - 100
      var bannerH = iniOffset + (window.innerHeight / 3.5) 

      if(x > iniOffset && x < bannerH){
        if(this.state.iniPos === null) {
          this.setState({
            iniPos: x,
            // p1: 10,
            // p2: 20,
            // p3: 40,
            // p4: 40,
            // p5: 50
          })
        }

        setTimeout(() => {
          var desloc = x - this.state.iniPos
          // console.log("desloc:",desloc)
          // console.log("iniPos:",this.state.iniPos)
          
          var sub1 = parseInt(desloc / 10)
          var sub2 = parseInt(desloc / 12)
          var sub3 = parseInt(desloc / 14)
          var sub4 = parseInt(desloc / 9)
          var sub5 = parseInt(desloc / 6)
          
          var max = 100
          var min = -max

          var p1 = this.state.p1 - sub1
              p1 = p1 < min ? min : p1
              p1 = p1 > max ? max : p1

          var p2 = this.state.p2 - sub2
              p2 = p2 < min ? min : p2
              p2 = p2 > max ? max : p2

          var p3 = this.state.p3 - sub3
              p3 = p3 < min ? min : p3
              p3 = p3 > max ? max : p3

          var p4 = this.state.p4 - sub4
              p4 = p4 < min ? min : p4
              p4 = p4 > max ? max : p4

          var p5 = this.state.p5 - sub5
              p5 = p5 < min ? min : p5
              p5 = p5 > max ? max : p5
          
          // console.log('p1:',p1)
          // console.log('p2:',p2)
          // console.log('p3:',p3)
          // console.log('p4:',p4)
          // console.log('p5:',p5)

          this.setState({
            p1: p1,
            p2: p2,
            p3: p3,
            p4: p4,
            p5: p5,
          })
  
          if(typeof finishParallax !== "undefined") clearTimeout(finishParallax)
  
          var finishParallax = setTimeout(() => {
            this.setState({iniPos: x})
          },100)
        },100)
      }
    }
  }

  componentWillReceiveProps () {
    this.updateParallax()
    // console.log('componentDidUpdate e:',e)
    // console.log('scroll e:',this.props.scroll)

  }
  
  setBanner = slide => {
    // console.log("slide:",slide)
    slide = slide > 6 ? slide - 7 : slide
    // console.log("slide:",slide)
    this.setState({activeSuco: slide})
  }

  openSucoDetails = suco => {
    var active = this.state.activeSuco

    if(suco === active){
      this.setState({
        activeSucoDetails: suco,
        sliderVisible: false,
        detailsVisible: true
      })

      setTimeout(() => {
        this.setState({showDetails: true})
      },600)
    }
  }
  
  closeDetails = () => {
    this.setState({
      activeSucoDetails: null,
      sliderVisible: true,
      detailsVisible: false,
      showDetails: false
    })
  }
  
  render() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 7,
      slidesToScroll: 1,
      swipeToSlide: false,
      centerPadding: 0,
      autoplay: false,
      centerMode: true,
      className: "center",
      draggable: false,
      touchMove: false,
      focusOnSelect: false,
      responsive:[
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            draggable: false,
            swipeToSlide: false,
            touchMove: false,
            focusOnSelect: false
          }
        }
      ]
    }

    return (
      <section id="produtos" className="produtos">
        <h3 className={this.state.sliderVisible ? "sucoNome" : "sucoNome off"} style={{color: this.state.sucos[this.state.activeSuco].color }}>
          { this.state.sucos[this.state.activeSuco].nome }
        </h3>
        <Slider {...settings} className={this.state.sliderVisible ? "bannerSlider produtosBanner on" : "bannerSlider produtosBanner"} afterChange={(slide) => { this.setBanner(slide) }}>
          <div className="slide" onClick={() => { this.openSucoDetails(0) }}>
            <img src={equilibrae} alt="equilibraê"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(1) }}>
            <img src={malaboroso} alt="malabaroso"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(2) }}>
            <img src={maca} alt="maçã"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(3) }}>
            <img src={badum} alt="badum"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(4) }}>
            <img src={uva} alt="uva"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(5) }}>
            <img src={pinklemonade} alt="pink lemonade"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(6) }}>
            <img src={xuaah} alt="xuaah"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(0) }}>
            <img src={equilibrae} alt="equilibraê"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(1) }}>
            <img src={malaboroso} alt="malabaroso"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(2) }}>
            <img src={maca} alt="maçã"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(3) }}>
            <img src={badum} alt="badum"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(4) }}>
            <img src={uva} alt="uva"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(5) }}>
            <img src={pinklemonade} alt="pink lemonade"/>
          </div>
          <div className="slide" onClick={() => { this.openSucoDetails(6) }}>
            <img src={xuaah} alt="xuaah"/>
          </div>
        </Slider>
        <div className={this.state.detailsVisible ? "detailsPage on" : "detailsPage"}>
          {
            // detalhes sucos - equilibrae
            this.state.activeSucoDetails === 0 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="equilibrae_morango">
                  <img src={equilibrae_morango} alt="morango"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="equilibrae_banana1">
                  <img src={equilibrae_banana1} alt="banana"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="equilibrae_banana2">
                  <img src={equilibrae_banana2} alt="banana"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="equilibrae_folha1">
                  <img src={equilibrae_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p4}px)` }} className="equilibrae_folha2">
                  <img src={equilibrae_folha2} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="equilibrae_maca">
                  <img src={equilibrae_maca} alt="maçã"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="equilibrae_maca_cortada">
                  <img src={equilibrae_maca_cortada} alt="maçã cortada"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={equilibrae} alt="equilibraê"/>
                <div>
                  <h2>
                    maçã,<br/>
                    banana, morango,<br/>
                    aroma natural, vitamina c<br/>
                    e corante natural
                  </h2>
                  <img src={equilibrae_tabela} alt="valores nutricionais - equilibraê"/>
                </div>
              </div>
            </section>
          }
          {
            // detalhes sucos - malabaroso
            this.state.activeSucoDetails === 1 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="malabaroso_manga">
                  <img src={malabaroso_manga} alt="manga"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="malabaroso_pessego">
                  <img src={malabaroso_pessego} alt="pêssego"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="malabaroso_laranja">
                  <img src={malabaroso_laranja} alt="laranja"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="malabaroso_folha1">
                  <img src={malabaroso_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p4}px)` }} className="malabaroso_folha2">
                  <img src={malabaroso_folha2} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p4}px)` }} className="malabaroso_folha3">
                  <img src={malabaroso_folha3} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="malabaroso_maca">
                  <img src={malabaroso_maca} alt="maçã"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={malaboroso} alt="malabaroso"/>
                <div>
                  <h2>
                    pêssego,<br/>
                    laranja, manga,<br/>
                    maçã, aroma natural,<br/>
                    e vitamina c
                  </h2>
                  <img src={malaboroso_tabela} alt="valores nutricionais - malabaroso"/>
                </div>
              </div>
            </section>
          }
          {
            // detalhes sucos - maçã
            this.state.activeSucoDetails === 2 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="maca_folha1">
                  <img src={maca_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="maca_folha2">
                  <img src={maca_folha2} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="maca_folha3">
                  <img src={maca_folha3} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="maca_maca">
                  <img src={maca_maca} alt="maçã"/>
                </div>
                <div style={{transform: `translateY(${this.state.p4}px)` }} className="maca_maca_cortada">
                  <img src={maca_maca_cortada} alt="maçã cortada"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={maca} alt="maçã"/>
                <div>
                  <h2>
                    maçã,<br/>
                    aroma natural,<br/>
                    e vitamina c
                  </h2>
                  <img src={maca_tabela} alt="valores nutricionais - maçã"/>
                </div>
              </div>
            </section>
          }
          {
            // detalhes sucos - badum
            this.state.activeSucoDetails === 3 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="badum_maca">
                  <img src={badum_maca} alt="maçã"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="badum_morango">
                  <img src={badum_morango} alt="morango"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="badum_folha1">
                  <img src={badum_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="badum_folha2">
                  <img src={badum_folha2} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="badum_tangerina">
                  <img src={badum_tangerina} alt="tangerina"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="badum_laranja">
                  <img src={badum_laranja} alt="laranja"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={badum} alt="badum"/>
                <div>
                  <h2>
                    laranja, maçã,<br/>
                    tangerina, morango,<br/>
                    aroma natural, vitamina c<br/>
                    e corante natural
                  </h2>
                  <img src={badum_tabela} alt="valores nutricionais - badum"/>
                </div>
              </div>
            </section>
          }
          {
            // detalhes sucos - uva
            this.state.activeSucoDetails === 4 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="uva_uva1">
                  <img src={uva_uva1} alt="uva"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="uva_uva2">
                  <img src={uva_uva2} alt="uva"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="uva_folha1">
                  <img src={uva_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="uva_folha2">
                  <img src={uva_folha2} alt="folha"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={uva} alt="uva" />
                <div>
                  <h2>
                    uva,<br/>
                    aroma natural<br/>
                    e vitamina c
                  </h2>
                  <img src={uva_tabela} alt="valores nutricionais - uva"/>
                </div>
              </div>
            </section>
          }
          {
            // detalhes sucos - pink lemonade
            this.state.activeSucoDetails === 5 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="pinklemonade_morango">
                  <img src={pinklemonade_morango} alt="morango"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="pinklemonade_limao">
                  <img src={pinklemonade_limao} alt="limao"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="pinklemonade_folha1">
                  <img src={pinklemonade_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p4}px)` }} className="pinklemonade_folha2">
                  <img src={pinklemonade_folha2} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="pinklemonade_maca">
                  <img src={pinklemonade_maca} alt="maçã"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="pinklemonade_maca_cortada">
                  <img src={pinklemonade_maca_cortada} alt="maçã"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={pinklemonade} alt="pink lemonade" />
                <div>
                  <h2>
                    maçã,<br/>
                    limão, morango,<br/>
                    aroma natural,<br/>
                    corante natural,<br/>
                    e vitamina c
                  </h2>
                  <img src={pinklemonade_tabela} alt="valores nutricionais - pink lemonade"/>
                </div>
              </div>
            </section>
          }
          {
            // detalhes sucos - xuaah
            this.state.activeSucoDetails === 6 &&
            <section>
              <div className="parallax">
                <div style={{transform: `translateY(${this.state.p1}px)` }} className="xuaah_maca">
                  <img src={xuaah_maca} alt="maçã"/>
                </div>
                <div style={{transform: `translateY(${this.state.p2}px)` }} className="xuaah_maca_cortada">
                  <img src={xuaah_maca_cortada} alt="maçã"/>
                </div>
                <div style={{transform: `translateY(${this.state.p5}px)` }} className="xuaah_abacaxi1">
                  <img src={xuaah_abacaxi1} alt="abacaxi"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="xuaah_abacaxi2">
                  <img src={xuaah_abacaxi2} alt="abacaxi"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="xuaah_folha1">
                  <img src={xuaah_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="xuaah_folha2">
                  <img src={xuaah_folha1} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="xuaah_folha3">
                  <img src={xuaah_folha3} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="xuaah_folha4">
                  <img src={xuaah_folha4} alt="folha"/>
                </div>
                <div style={{transform: `translateY(${this.state.p3}px)` }} className="xuaah_folha5">
                  <img src={xuaah_folha5} alt="folha"/>
                </div>
              </div>
              <div className={this.state.showDetails ? "on details" : "details"}>
                <a href="#" onClick={(e) => {e.preventDefault(); this.closeDetails() }} className="btClose">
                  <FontAwesomeIcon icon={faTimes} color="#FFF" />
                </a>
                <img src={xuaah} alt="xuaah"/>
                <div>
                  <h2>
                  Abacaxi,<br/>
                  maçã, chá verde, <br/> 
                  hortelã, vitamina c <br/> 
                  e aroma natural
                  </h2>
                  <img src={xuaah_tabela} alt="valores nutricionais - xuaah"/>
                </div>
              </div>
            </section>
          }
        </div>
        <div className={this.state.detailsVisible ? "produtosBannerBg bgOnly" : "produtosBannerBg"}>
          <div style={{backgroundColor: this.state.sucos[this.state.activeSuco].bg[0]}}></div>
          <div style={{backgroundColor: this.state.sucos[this.state.activeSuco].bg[1]}}></div>
          <div style={{backgroundColor: this.state.sucos[this.state.activeSuco].bg[2]}}></div>
        </div>
      </section>
    )
  }
}

export default Produtos